import { memo, splitProps } from '../helpers.mjs';
import { createRecipe, mergeRecipes } from './create-recipe.mjs';

const tabsPanelFn = /* @__PURE__ */ createRecipe('tabs-panel', {}, [])

const tabsPanelVariantMap = {}

const tabsPanelVariantKeys = Object.keys(tabsPanelVariantMap)

export const tabsPanel = /* @__PURE__ */ Object.assign(memo(tabsPanelFn.recipeFn), {
  __recipe__: true,
  __name__: 'tabsPanel',
  __getCompoundVariantCss__: tabsPanelFn.__getCompoundVariantCss__,
  raw: (props) => props,
  variantKeys: tabsPanelVariantKeys,
  variantMap: tabsPanelVariantMap,
  merge(recipe) {
    return mergeRecipes(this, recipe)
  },
  splitVariantProps(props) {
    return splitProps(props, tabsPanelVariantKeys)
  },
  getVariantProps: tabsPanelFn.getVariantProps,
})